<template>
  <div class="ecs-http-progressbar">
    <v-progress-circular
      class="http-progressbar"
      :class="{ show: requestCount && realProgressValue !== 100 }"
      :color="$vuetify.theme.dark ? 'var(--v-accent-base)' : 'var(--v-surface-base)'"
      size="36"
      width="3"
      indeterminate
    >
      <span class="progress-label">{{ realProgressValue }}%</span>
    </v-progress-circular>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// Ref. https://xhr.spec.whatwg.org/#states
const XHR_READY_STATE = {
  UNSENT: 0,
  OPENED: 1,
  HEADERS_RECEIVED: 2,
  LOADING: 3,
  DONE: 4
};

export default {
  name: 'EcsHttpProgressbar',

  components: {},

  data() {
    return {
      requestCount: 0,
      started: 0,
      completed: 0
    };
  },

  computed: {
    ...mapGetters('AGENT', ['isSupervisor']),

    realProgressValue() {
      let dx = this.started - this.completed;
      dx = dx < 1 ? 1 : dx;
      return Math.round(100 / dx);
    },

    value() {
      let displayProgressValue = this.realProgressValue;

      if (!displayProgressValue && displayProgressValue !== 0) {
        displayProgressValue = 100;
      } else if (displayProgressValue === 0) {
        displayProgressValue = 20;
      } else if (this.started === this.completed) {
        displayProgressValue = 0;
      }

      return displayProgressValue;
    }
  },

  watch: {
    requestCount() {
      if (this.requestCount === 0) {
        this.started = 0;
        this.completed = 0;
      }
    }
  },

  mounted() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    const self = this;

    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      self.requestCount++;
      self.started++;
      return originalOpen.apply(this, [method, url, ...args]);
    };

    XMLHttpRequest.prototype.send = function(...args) {
      const originalOnreadystatechange = this.onreadystatechange;

      this.onreadystatechange = function() {
        if (this.readyState === XHR_READY_STATE.DONE) {
          self.requestCount--;
          self.completed++;
        }

        if (originalOnreadystatechange) {
          originalOnreadystatechange.apply(this, args);
        }
      };

      return originalSend.apply(this, args);
    };
  },

  beforeDestroy() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.ecs-http-progressbar {
  width: 36px;
  height: 36px;
  margin-right: 4px;
  transition: all 0.2s ease-out;

  &:has(.show) {
    background-color: #0002;
    border-radius: 36px;
  }

  .http-progressbar {
    opacity: 0;
    transition: opacity 0.2s ease-out;
    transform: rotateZ(-90deg);

    .progress-label {
      font-size: 10px;
      color: #fffc;
      transform: rotateZ(90deg);
    }

    &.show {
      opacity: 1;
    }
  }
}
</style>
